<template>
    <div class="modal is-active is-clipped">
        <div class="modal-background" @click="onClose ? onClose() :  $parent.hideModal()" />
        <div class="modal-content" :class="modalContentSizeClass ? modalContentSizeClass : 'modal-content-size'">
            <button class="modal-close is-large" aria-label="close" @click="onClose ? onClose() : $parent.hideModal()" />
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Modal',
    props: [
        'onClose',
        'modalContentSizeClass'
    ]
}
</script>

<style lang="scss" scoped>
.modal-content {
    background-color: $secondary;
    margin: 0 auto;
    border-radius: 15px;
    padding: 3em 1.5rem;

    .modal-close {
        position: absolute;

        &:before,
        &:after {
            background-color: $primary;
        }
    }
}
.modal-content-size {
  max-height: 80%;
  max-width: 480px; //600px * 80%
  width: 80%;
}
</style>